export default function Footer() {
  const navLinks = [
    { label: 'О конференции', href: '#about' },
    { label: 'Программа', href: '#program' },
    { label: 'Стендап', href: '#standup' },
    { label: 'Как попасть', href: '#how-to-get' },
    { label: 'Организаторы', href: '#organizers' },
  ];

  const socials = [
    { icon: 'ri-vk-line', label: 'VK', href: 'https://vk.com/protivboli' },
    { icon: 'ri-youtube-line', label: 'YouTube', href: 'https://www.youtube.com/@%D0%A1%D0%97%D0%9E%D0%98%D0%91' },
    { icon: 'ri-video-line', label: 'VK Видео', href: 'https://vkvideo.ru/@protivboli' },
    { icon: 'ri-tv-line', label: 'RuTube', href: 'https://rutube.ru/channel/24339226' },
  ];

  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#0f3d32] text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 flex items-center justify-center bg-[#c8963e] rounded-xl">
                <i className="ri-brain-line text-white text-lg"></i>
              </div>
              <div>
                <div className="font-extrabold text-white text-lg leading-tight">NeuroRussia 2026</div>
                <div className="text-white/40 text-xs">НЭСПРИМ + СЗОИБ</div>
              </div>
            </div>
            <p className="text-white/50 text-sm leading-relaxed mb-5 max-w-xs">
              Всероссийская медицинская конференция. Междисциплинарные диалоги, медицинский стендап и AI-консультант в Санкт-Петербурге.
            </p>
            <a href="mailto:info@painmed.ru"
              className="inline-flex items-center gap-2 text-[#c8963e] text-sm font-semibold hover:text-[#e0aa50] transition-colors">
              <i className="ri-mail-line"></i>info@painmed.ru
            </a>
          </div>

          <div>
            <h4 className="text-white/40 text-xs font-semibold uppercase tracking-wider mb-5">Разделы</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <button onClick={() => scrollTo(link.href)}
                    className="text-white/60 text-sm hover:text-white transition-colors cursor-pointer">
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white/40 text-xs font-semibold uppercase tracking-wider mb-5">Мы в соцсетях</h4>
            <div className="flex flex-wrap gap-3 mb-6">
              {socials.map((s) => (
                <a key={s.label} href={s.href} target="_blank" rel="nofollow noreferrer" aria-label={s.label}
                  className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-xl hover:bg-[#c8963e] text-white transition-colors cursor-pointer">
                  <i className={`${s.icon} text-lg`}></i>
                </a>
              ))}
            </div>
            <div className="space-y-2.5">
              {[
                { label: 'painmed.ru', href: 'https://painmed.ru' },
                { label: 'нэсприм.рф', href: 'https://нэсприм.рф' },
                { label: 'Политика конфиденциальности', href: '#' },
              ].map((link) => (
                <a key={link.label} href={link.href}
                  className="block text-white/40 text-xs hover:text-white transition-colors" rel="nofollow">
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs">© 2026 НЭСПРИМ, СЗОИБ, Painmed. Все права защищены.</p>
          <p className="text-white/20 text-xs">NeuroRussia 2026 • Санкт-Петербург • 16–17 апреля</p>
        </div>
      </div>
    </footer>
  );
}
